// @generated by protoc-gen-es v1.10.0
// @generated from file ai/h2o/mlops/storage/v1/user_service.proto (package ai.h2o.storage, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { User } from "./user_pb.js";
import { FilterRequest, PagingRequest, PagingResponse, SortingRequest } from "./listing_pb.js";

/**
 * @generated from message ai.h2o.storage.GetUserRequest
 */
export const GetUserRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.GetUserRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.GetUserResponse
 */
export const GetUserResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.GetUserResponse",
  () => [
    { no: 1, name: "user", kind: "message", T: User },
  ],
);

/**
 * @generated from message ai.h2o.storage.BatchGetUsersRequest
 */
export const BatchGetUsersRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.BatchGetUsersRequest",
  () => [
    { no: 1, name: "IDs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message ai.h2o.storage.BatchGetUsersResponse
 */
export const BatchGetUsersResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.BatchGetUsersResponse",
  () => [
    { no: 1, name: "users", kind: "message", T: User, repeated: true },
  ],
);

/**
 * @generated from message ai.h2o.storage.GetUserByUsernameRequest
 */
export const GetUserByUsernameRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.GetUserByUsernameRequest",
  () => [
    { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.GetUserByUsernameResponse
 */
export const GetUserByUsernameResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.GetUserByUsernameResponse",
  () => [
    { no: 1, name: "user", kind: "message", T: User },
  ],
);

/**
 * @generated from message ai.h2o.storage.CreateUserRequest
 */
export const CreateUserRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.CreateUserRequest",
  () => [
    { no: 1, name: "user", kind: "message", T: User },
  ],
);

/**
 * @generated from message ai.h2o.storage.CreateUserResponse
 */
export const CreateUserResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.CreateUserResponse",
  () => [
    { no: 1, name: "user", kind: "message", T: User },
  ],
);

/**
 * @generated from message ai.h2o.storage.ListUsersRequest
 */
export const ListUsersRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.ListUsersRequest",
  () => [
    { no: 1, name: "paging", kind: "message", T: PagingRequest },
    { no: 2, name: "filter", kind: "message", T: FilterRequest },
    { no: 3, name: "sorting", kind: "message", T: SortingRequest },
  ],
);

/**
 * @generated from message ai.h2o.storage.ListUsersResponse
 */
export const ListUsersResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.ListUsersResponse",
  () => [
    { no: 1, name: "paging", kind: "message", T: PagingResponse },
    { no: 2, name: "user", kind: "message", T: User, repeated: true },
  ],
);

/**
 * @generated from message ai.h2o.storage.WhoAmIRequest
 */
export const WhoAmIRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.WhoAmIRequest",
  [],
);

/**
 * @generated from message ai.h2o.storage.WhoAmIResponse
 */
export const WhoAmIResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.WhoAmIResponse",
  () => [
    { no: 1, name: "user", kind: "message", T: User },
  ],
);

